<template>
	<div v-parallax-fit="parallax" class="slide-root">
		<img src="/themes/rise-theme/dist/images/estate/character-view/henry/02_roots.png" alt="">
	</div>
</template>

<script>
	export default {
		data() {
			return {
				parallax: [
					{
						start: 0,
						end: 400,
						fromStyle: { transform: 'translateY(0%)', opacity: 0 },
          				toStyle: { transform: 'translateY(48%)', opacity: 1 },
						easing: 'linear'
					},
					{
						start: 5200,
						end: 5300,
						fromStyle: { transform: 'translateY(70%)', opacity: 1  },
          				toStyle: { transform: 'translateY(-0%)', opacity: 0  },
						easing: 'linear'
					},
					{
						start: 25500,
						end: 27000,
						fromStyle: { transform: 'translateY(0%)', opacity: 0  },
          				toStyle: { transform: 'translateY(48%)', opacity: 1  },
						easing: 'linear'
					}
				]
			}
		}
	}
</script>

<style lang="scss" scoped>
	.slide-root {
		position: absolute;
	    left: -3%;
	    bottom: 0;
	    max-width: 600px;
	    z-index: -1;
	    transition: all 0.1s linear;
	}

	@media screen and (max-width: 1680px) {
		.slide-root {
			max-width: 550px;
			bottom: -10%;
		}
    }

    @media screen and (max-width: 1280px) {
    	.slide-root {
	    	max-width: 350px;
		    bottom: -9%;
		    left: -8%;
    	}
    }

    @media screen and (max-width: 650px) {
    	.slide-root {max-width: 175px;}
    }
</style>
